var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46447 18.5355C2.92893 20 5.28595 20 10 20C14.714 20 17.0711 20 18.5355 18.5355C20 17.0711 20 14.714 20 10C20 5.28595 20 2.92893 18.5355 1.46447C17.0711 -1.19209e-07 14.714 0 10 0C5.28595 0 2.92893 -1.19209e-07 1.46447 1.46447C-1.19209e-07 2.92893 0 5.28595 0 10C0 14.714 -1.19209e-07 17.0711 1.46447 18.5355ZM7.96967 13.5303C7.67678 13.2374 7.67678 12.7626 7.96967 12.4697L10.4393 10L7.96967 7.53033C7.67678 7.23744 7.67678 6.76256 7.96967 6.46967C8.2626 6.17678 8.7374 6.17678 9.0303 6.46967L12.0303 9.4697C12.171 9.6103 12.25 9.8011 12.25 10C12.25 10.1989 12.171 10.3897 12.0303 10.5303L9.0303 13.5303C8.7374 13.8232 8.2626 13.8232 7.96967 13.5303Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfter);
export default __webpack_public_path__ + "static/media/after.e67be0f1b179452fd1267cbd8ec7f415.svg";
export { ForwardRef as ReactComponent };